import React, { useState, useEffect, forwardRef, useImperativeHandle } from "react";
import { Popover } from "antd";
import { PlusOutlined, StarOutlined, RightOutlined } from "@ant-design/icons";
import { openPage, isMatch } from "./menu";
import { lib } from "../index";

// col 模式 - 展开/收起模式
function FavoriteMenuCol({ favoriteMenuList, onAddClick }) {
    const [isOpen, setOpen] = useState(true);
    const transform = `rotate(${isOpen ? 90 : 0}deg)`;

    return (
        <div className="group favorite-group">
            <div className="item favorite-header" onClick={() => setOpen(!isOpen)} style={{ paddingLeft: "24px" }}>
                <StarOutlined className="icon" />
                <span className="title">常用</span>
                <PlusOutlined
                    className="add-icon"
                    onClick={e => {
                        e.stopPropagation();
                        onAddClick();
                    }}
                />
                {favoriteMenuList.length !== 0 && (
                    <RightOutlined className="icon-down" style={{ fontSize: "14px", transform }} />
                )}
            </div>
            {isOpen &&
                favoriteMenuList.map((item, key) => (
                    <div
                        key={key}
                        className={`item favorite-menu-item ${isMatch(item.url, true) ? "active" : ""}`}
                        onClick={() => openPage(item.url)}
                        style={{ paddingLeft: "24px" }}>
                        <span className="title">{item.title}</span>
                    </div>
                ))}
        </div>
    );
}

// mini 模式 - Popover 模式
function FavoriteMenuMini({ favoriteMenuList, onAddClick }) {
    return (
        <Popover
            placement="right"
            content={
                <>
                    <div className="item" onClick={onAddClick}>
                        <PlusOutlined style={{ marginRight: "8px" }} />
                        添加常用
                    </div>
                    {favoriteMenuList.map((item, key) => (
                        <div
                            key={key}
                            className={`item ${isMatch(item.url) ? "active" : ""}`}
                            onClick={() => openPage(item.url)}>
                            {item.title}
                        </div>
                    ))}
                </>
            }
            overlayClassName="react-single-app-popover">
            <div className={`item`}>
                <span className="icon">
                    <StarOutlined />
                </span>
            </div>
        </Popover>
    );
}

// 主组件
const FavoriteMenu = forwardRef(({ menuType, menuList, onAddClick }, ref) => {
    const [favoriteMenuList, setFavoriteMenuList] = useState([]);

    // 从接口加载常用菜单
    const loadFavorites = () => {
        if (!menuList || menuList.length === 0) {
            return;
        }

        lib.request({
            url: "/ucenter-account/frequentMenu/list",
            data: {
                systemCode: lib.config.systemCode,
            },
            success: data => {
                // 接口返回格式：[{ code, icon, id, systemCode, title, url }]
                // 需要验证菜单是否有效
                const favoriteItems = (data || [])
                    .map(item => {
                        return {
                            id: item.id,
                            title: item.title,
                            url: item.url + (item.url.includes("?") ? "&" : "?") + "commonMenuFlag=true",
                            icon: item.icon,
                        };
                    })
                    .filter(item => item !== null);
                setFavoriteMenuList(favoriteItems || []);
            },
            fail: () => {
                console.error("加载常用菜单失败");
            },
        });
    };

    // 暴露刷新方法给父组件
    useImperativeHandle(ref, () => ({
        refresh: () => {
            loadFavorites();
        },
    }));

    useEffect(() => {
        loadFavorites();
    }, [menuList]);

    // 如果没有常用菜单，不显示
    if (favoriteMenuList.length === 0 && menuType === "mini") {
        return null;
    }

    if (menuType === "col") {
        return <FavoriteMenuCol favoriteMenuList={favoriteMenuList} onAddClick={onAddClick} />;
    } else {
        return <FavoriteMenuMini favoriteMenuList={favoriteMenuList} onAddClick={onAddClick} />;
    }
});

export default FavoriteMenu;
